/**
 * /dashboard/hr/onboarding/$id — Single onboarding-instance detail
 * (Phase 3c — 2026-06-01).
 *
 * GET /hr/onboarding/{id} 404s a non-authorized caller (HR / the
 * subject / the subject's direct manager are the only readers — no
 * existence oracle), so reaching this view means the caller may read
 * it. Task complete/skip authz + the instance recompute are
 * server-side; OnboardingDetail handles the loading / not-available /
 * error states and reconciles from the server's recomputed response.
 *
 * Migration note (2026-06-01, Next.js → Vite): port of
 * frontend/src/app/(dashboard)/dashboard/hr/onboarding/[id]/page.tsx +
 * layout.tsx, flattened into one route that uses HrModuleShell. Swaps:
 *   - "use client" dropped
 *   - use(params) (Next.js) → Route.useParams() (TanStack)
 */

import { createFileRoute } from "@tanstack/react-router";
import { HrFeatureGate } from "@/components/hr/hr-feature-gate";
import { HrModuleShell } from "@/components/shared/hr-module-shell";
import { OnboardingDetail } from "@/components/hr/onboarding-detail";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/hr/onboarding/$id",
)({
  component: HrOnboardingDetailRoute,
});

function HrOnboardingDetailRoute() {
  const { id } = Route.useParams();
  const numId = Number(id);

  return (
    <HrModuleShell
      title="Onboarding"
      description="Checklist progress and per-task actions."
    >
      <HrFeatureGate>
        {Number.isFinite(numId) && numId > 0 ? (
          <OnboardingDetail instanceId={numId} />
        ) : (
          <p className="text-sm text-muted-foreground">
            Invalid onboarding reference.
          </p>
        )}
      </HrFeatureGate>
    </HrModuleShell>
  );
}
